import React, { useMemo } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { findBook, getCurrentVersion } from "../lib/bible";

export default function BibliaLivro() {
  const { book: slug } = useParams();
  const book = useMemo(() => findBook(slug), [slug]);
  const version = useMemo(() => getCurrentVersion(), []);

  if (!book) {
    return (
      <div className="max-w-3xl mx-auto section-padding py-10" data-testid="bible-book-not-found">
        <p className="font-display text-2xl text-navy">Livro não encontrado.</p>
        <Link
          to="/biblia"
          className="inline-flex items-center gap-2 text-xs uppercase tracking-widest text-gold mt-6"
        >
          <ArrowLeft className="w-4 h-4" /> Voltar para Bíblia
        </Link>
      </div>
    );
  }

  return (
    <div className="max-w-3xl mx-auto section-padding py-8" data-testid="bible-book-page">
      <Link
        to="/biblia"
        className="inline-flex items-center gap-2 text-xs uppercase tracking-widest text-navy/60 hover:text-navy mb-6"
        data-testid="bible-book-back"
      >
        <ArrowLeft className="w-4 h-4" /> Bíblia
      </Link>

      <div className="mb-10">
        <p className="text-[10px] uppercase tracking-[0.3em] text-navy/50">
          {book.testament} · Versão {version.name}
        </p>
        <h1 className="font-display text-4xl sm:text-5xl text-navy mt-2" data-testid="bible-book-title">
          {book.name}
        </h1>
        <p className="text-navy/65 mt-3 text-sm">
          {book.total_chapters} {book.total_chapters === 1 ? "capítulo" : "capítulos"} · selecione um capítulo abaixo
        </p>
      </div>

      <div className="grid grid-cols-5 sm:grid-cols-8 md:grid-cols-10 gap-2.5" data-testid="bible-book-chapters">
        {Array.from({ length: book.total_chapters }, (_, i) => i + 1).map((n) => (
          <Link
            key={n}
            to={`/biblia/${book.slug}/${n}`}
            data-testid={`bible-chapter-link-${n}`}
            className="aspect-square flex items-center justify-center rounded-xl text-sm font-display transition-colors border bg-white border-gold/40 text-navy hover:bg-gold hover:text-navy"
          >
            {n}
          </Link>
        ))}
      </div>
    </div>
  );
}
